// extracted by mini-css-extract-plugin
module.exports = {"premium":"PremiumMembership_premium__tLqML"};